export default __webpack_public_path__ + "static/media/testi1.3587b87f.png";